import { Cancel } from "@mui/icons-material";
import CropIcon from "@mui/icons-material/Crop";
import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  Slider,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import Cropper from "react-easy-crop";
import getCroppedImg from "./cropImage";
import { useEffect } from "react";
// import 'react-easy-crop/style.css';


const CropEasy = ({
  photoURLSide,
  photoURLMain,
  setOpenCrop,
  setPhotoURLSide,
  setPhotoURLMain,
  setFileSide,
  setFileMain,
  setPhotoMain,
  setPhotoSide,
  type,
}) => {
  const [crop, setCrop] = useState({ x: 0, y: 0, width: 100, height: 200 });
  const [zoom, setZoom] = useState(1);
  const [rotation, setRotation] = useState(0);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [imageSize, setImageSize] = useState({ width: 1, height: 1 });

  const calculateInitialZoom = (imageSize, aspectRatio) => {
    const { width, height } = imageSize;
    const imageAspectRatio = width / height;

    if (imageAspectRatio >= aspectRatio) {
      return height / width * aspectRatio;
    } else {
      return 1;
    }
  };

  useEffect(() => {
    const image = new Image();
    image.src = photoURLMain;

    image.onload = () => {
      const { naturalWidth, naturalHeight } = image;
      setImageSize({ width: naturalWidth, height: naturalHeight });
    };
  }, [photoURLMain]);

  const cropComplete = (croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  };

  const handleCropChange = (crop) => {
    setCrop(crop);
  };

  useEffect(() => {
    if (!imageSize.width || !imageSize.height) {
      return;
    }

    const initialZoom = calculateInitialZoom(imageSize, aspectRatio);
    setZoom(initialZoom);

    // You can set the initial rotation here as well if needed
  }, [imageSize]);

  const cropImage = async () => {
    const { file, url } = await getCroppedImg(
      photoURLMain,
      croppedAreaPixels,
      rotation
    );

    // Create a new Image object
    const image = new Image();

    // Set the source of the Image object to the cropped file
    image.src = URL.createObjectURL(file);

    // When the Image is loaded, create a canvas, draw the image, and convert it to a data URL
    image.onload = () => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      const desiredWidth = 300; // Set your desired width here
      const desiredHeight = 200; // Set your desired height here

      // Set canvas size to desired dimensions
      canvas.width = desiredWidth;
      canvas.height = desiredHeight;

      // Draw the image onto the canvas with the desired dimensions
      ctx.drawImage(image, 0, 0, desiredWidth, desiredHeight);

      // Convert the canvas content to a data URL
      const croppedImageUrl = canvas.toDataURL('image/jpeg');

      setPhotoURLMain(croppedImageUrl);
      setFileMain(file);
      setOpenCrop(false);
      var reader = new FileReader();
      reader.onloadend = function () {
        setPhotoMain(reader.result);
      };
      reader.readAsDataURL(file);
    };
  };

  // const cropImage = async () => {
  //   const { file, url } = await getCroppedImg(
  //     photoURLMain,
  //     croppedAreaPixels,
  //     rotation
  //   );
  //   setPhotoURLMain(url);
  //   setFileMain(file);
  //   setOpenCrop(false);
  //   var reader = new FileReader();
  //   reader.onloadend = function () {
  //     console.log(reader.result,"reader.result")
  //     setPhotoMain(reader.result)
  //   };
  //   reader.readAsDataURL(file);
  // };

  const aspectRatio = imageSize.width / imageSize.height;

  return (
    <>
      <DialogContent
        dividers
        sx={{
          background: "#333",
          position: "relative",
          height: 400,
          width: "auto",
          minWidth: { sm: 500 },
        }}
      >
        <Cropper
          image={photoURLMain}
          crop={crop}
          zoom={zoom}
          rotation={rotation}
          aspect={4 / 4}
          onZoomChange={setZoom}
          onRotationChange={setRotation}
          onCropChange={handleCropChange}
          onCropComplete={cropComplete}
          cropShape="round"
        />
      </DialogContent>
      <DialogActions sx={{ flexDirection: "column", mx: 3, my: 2 }}>
        <Box sx={{ width: "100%", mb: 1 }}>
          <Box>
            <Typography>Zoom: {zoomPercent(zoom)}</Typography>
            <Slider
              valueLabelDisplay="auto"
              valueLabelFormat={zoomPercent}
              min={1}
              max={3}
              step={0.1}
              value={zoom}
              onChange={(e, zoom) => setZoom(zoom)}
            />
          </Box>
          <Box>
            <Typography>Rotation: {rotation + "°"}</Typography>
            <Slider
              valueLabelDisplay="auto"
              min={0}
              max={360}
              value={rotation}
              onChange={(e, rotation) => setRotation(rotation)}
            />
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            gap: 2,
            flexWrap: "wrap",
          }}
        >
          <Button
            variant="outlined"
            startIcon={<Cancel />}
            onClick={() => setOpenCrop(false)}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            startIcon={<CropIcon />}
            onClick={cropImage}
          >
            Crop
          </Button>
        </Box>
      </DialogActions>
    </>
  );
};

export default CropEasy;

const zoomPercent = (value) => {
  return `${Math.round(value * 100)}%`;
};
